export enum BadgeEditorStep {
  EVENT_SELECTION,
  PERSONA_SELECTION,
  TEMPLATE_SELECTION,
  BADGE_PREVIEW
}
